<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.pull_bill_by_policy')}}</div>
    <div slot="body">
      <a-form
        :form="form.fc"
        v-bind="formItemLayout">
        <a-form-item :label="$t('bill.month')">
          <a-month-picker
            v-decorator="decorators.month"
            format="YYYY-MM"
            :placeholder="$t('common.tips.select', [$t('bill.month')])" />
        </a-form-item>
        <a-form-item :label="$t('bill.text_60')">
          <base-select
            v-decorator="decorators.account_id"
            resource="cloudaccounts"
            filterable
            :remote="true"
            :params="cloudaccountParams"
            :remote-fn="q => ({ filter: `name.contains(${q})` })"
            :select-props="{ placeholder: $t('common.tips.select', [$t('bill.text_60')]) }" />
        </a-form-item>
     </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BillPullBillingDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      decorators: {
        month: ['month', {
          initialValue: this.$moment(),
          rules: [
            { required: true, message: this.$t('common.tips.select', [this.$t('bill.month')]) },
          ],
        }],
        account_id: [
          'account_id',
          {
            rules: [
              { required: true, message: this.$t('common.tips.select', [this.$t('bill.text_60')]) },
            ],
          },
        ],
      },
      cloudaccountParams: {
        scope: this.$store.getters.scope,
        // brand: 'Aliyun',
      },
    }
  },
  created () {
    this.$bM = new this.$Manager('billtasks/submit', 'v1')
  },
  methods: {
    async handleConfirm () {
      try {
        const values = await this.form.fc.validateFields()
        this.loading = true
        await this.$bM.create({
          data: {
            account_id: values.account_id,
            month: this.$moment(values.month).format('YYYYMM'),
            task_type: 'pull_bill',
          },
        })
        this.cancelDialog()
      } catch (err) {
        throw err
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
  .messages-list p{
    margin-bottom: 2px;
  }
</style>
